import { TEXT_TYPES } from '@/constants/personalization-studio'

function unescapeHtml(text) {
  if (typeof text !== 'string') return text
  return text.replace(/\\"/g, '"').replace(/\\'/g, "'")
}


function screenReaderContent(text) {
  if (typeof text !== 'string') return text
  return text
    .replace(/</g, '')
    .replace(/(\d{1,3}(?:,\d{3})*)(\s*)(pts)\b/gi, '$1$2points')
    .replace(/(\d{1,3}(?:,\d{3})*)(\s*)(pt)\b/gi, '$1$2point')
    .replace(/\bpts\b/gi, 'points')
    .replace(/\bpt\b/gi, 'point')
    .replace(/\bTerms\b/g, 'Terms for PayPal debit cards')
    .replace(/\s+/g, ' ')
    .trim()
}

function processText(text) {
  if (typeof text !== 'string') return text
  
  return text.replace(
    /<a([^>]*)>\s*Terms\s*<\/a>/g,
    '<a$1 role="link" aria-label="Terms for PayPal debit cards">Terms</a>'
  )
}


export function mapUcsToPsBlocks(arrangedRecommendations = []) {
  const mergedContent = arrangedRecommendations.reduce((acc, item) => {
    const content = item?.content || {}
    for (const [key, value] of Object.entries(content)) {
      if (key.startsWith('ucs')) {
        const htmlContentFields = [
          'ucsOfferDesc1', 'ucsOfferDesc2', 'ucsOfferDesc3',
          'ucsOfferBody1', 'ucsOfferBody2', 'ucsOfferLegal',
          'ucsInfoText', 'ucsAltInfoText', 'ucsAltOfferDesc1'
        ]
        acc[key] = htmlContentFields.includes(key) ? unescapeHtml(value) : value
      }
    }
    return acc
  }, {})

  const blocks = []


  // Heading
  if (mergedContent.ucsInfoText) {
    blocks.push({
      content: {
        infoType: 'HEADER',
        infoTextMetadata: [{ font_size: TEXT_TYPES.HEADING }],
        infoText: mergedContent.ucsInfoText,
        'aria-label': screenReaderContent(mergedContent.ucsInfoText),
      },
    })
  }

  // Image
  if (mergedContent.ucsImage) {
    blocks.push({
      content: {
        imageType: 'URL',
        image: mergedContent.ucsImage,
        ...(mergedContent.ucsImageWidth ? { imageWidth: mergedContent.ucsImageWidth } : {}),
        ...(mergedContent.ucsImageHeight ? { imageHeight: mergedContent.ucsImageHeight } : {}),
        imageAccessibilityText: 'PayPal Debit Card',
      },
    })
  }

  // Checkmark Lists
  ;['ucsOfferDesc1', 'ucsOfferDesc2', 'ucsOfferDesc3'].forEach((key) => {
    const text = mergedContent[key]
    if (text) {
      blocks.push({
        content: {
          infoType: 'PRIMARY',
          infoTextMetadata: [{ font_size: TEXT_TYPES.BODY }],
          infoText: processText(text),
          infoWithBullet: true,
          'aria-label': screenReaderContent(text),
        },
      })
    }
  })


  // Two body and one legal content
  ;['ucsOfferBody1', 'ucsOfferBody2', 'ucsOfferLegal'].forEach((key) => {
    let text = mergedContent[key]
    if (text) {
      blocks.push({
        content: {
          infoType: 'PRIMARY',
          infoTextMetadata: [{ font_size: TEXT_TYPES.CAPTION }],
          infoText: processText(text),
          'aria-label': screenReaderContent(text),
        },
      })
    }
  })

  // CTA Button
  if (mergedContent.ucsCtaButton) {
    blocks.push({
      content: {
        buttonType: 'PRIMARY',
        buttonTitle: mergedContent.ucsCtaButton,
      },
    })
  }

  return blocks
}

export default mapUcsToPsBlocks 